import axios from "axios";

export default function GuestAllowService(guestId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/guest/" + guestId + "/allow",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
